const mainSearchForm = {
  flights: "เที่ยวบิน", // translated
  tours: "ทัวร์", // translated
  hotel: "โรงแรม", // translated
  hotels: "โรงแรม", // translated
  services: "บริการ", // translated
  search: "ค้นหา", // translated
  destination: "ปลายทาง", // translated
  includedServices: "บริการที่รวมอยู่", // translated
  packageDuration: "ระยะเวลาของแพ็คเกจ", // translated
  checkInOut: "เช็คอิน/เช็คเอาท์", // translated
  guests: "แขก", // translated
  adults: "ผู้ใหญ่", // translated
  children: "เด็ก", // translated
  child: "เด็ก", // translated
  age: "อายุ", // translated
  yearsOld: "ปี", // translated
  rooms: "ห้องพัก", // translated
  close: "ปิด", // translated
  searchType: "ประเภทการค้นหา", // translated
  accommodation: "ที่พัก", // translated
  transfers: "การโอน", // translated
  toursExperiences: "ทัวร์/ประสบการณ์", // translated
  nights: "คืน", // translated
  days: "วัน", // translated
  packageType: "ประเภทแพ็คเกจ", // translated
  tourType: "ประเภททัวร์", // translated
  packages: "แพ็คเกจ", // translated
  cars: "รถ", // translated
  cruises: "เรือสำราญ", // translated
  infantsInSeat: "ทารกอยู่ในที่นั่ง", // translated
  infantsOnLap: "ทารกอยู่บนตัก", // translated
  airport: "สนามบิน", // translated
  passengers: "ผู้โดยสาร", // translated
  departureReturn: "วันที่ออกเดินทางและกลับ", // translated
  origin: "ต้นทาง", // translated
  roundTrip: "ไป - กลับ", // translated
  isRoundTrip: "เป็นไปกลับ", // translated
  dream_packages: "แพ็คเกจในฝัน", // translated
  partying: "ปาร์ตี้", // translated
  thingsToDo: "สิ่งที่ต้องทำ", // translated
};


export default mainSearchForm;
